const SET_CHECKED_TUTORIALS = 'tutorials/SET_CHECKED_TUTORIALS';
const CHECK_TUTORIAL = 'tutorials/CHECK_TUTORIAL';

export default {
  SET_CHECKED_TUTORIALS,
  CHECK_TUTORIAL,
};



// WEBPACK FOOTER //
// ./src/app/tutorials/store/mutation-types.js